module.exports = __webpack_public_path__ + "static/media/ApercuPro-Bold.f7a81f9b.woff";